import { useQuery } from "@tanstack/react-query";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { BASE_URL, IMAGE_BASE_URL } from "../data/baseURL";
import { useScrollTop } from "../hook/useScrollTop";
import { CompanyLocationMaps } from "../sections/company-location";
import ContactFormModal from "./contactFormModal";

const formatOptionLabel = ({ value, label, icon }) => (
  <div style={{ display: "flex", alignItems: "center" }} className="fs-14 py-2">
    <div style={{ marginRight: "10px", color: "#ccc" }}>
      <img src={`${IMAGE_BASE_URL}/${icon}`} alt="" className="img-fluid" />
    </div>
    <div>{label}</div>
  </div>
);

const CountryMap = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedContactForm, setSelectedContactForm] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedCountryDetails, setSelectedCountryDetails] = useState(null);
  const { data, isLoading } = useQuery(["company-country"], async () => {
    const response = await window.fetch(`${BASE_URL}/contact-country`);
    return await response.json();
  });

  useScrollTop();

  if (isLoading) {
    return "";
  }

  const close = () => setShowModal(false);

  function handleShowContactForm(selectedId) {
    setShowModal(true);
    setSelectedContactForm(selectedId);
  }

  const companies = data?.countries;

  function handleSelect(event) {
    const { value } = event;
    const defaultSelectCountry = data?.countries?.find(
      (option) => Number(option.id) === Number(value)
    );

    setSelectedCountry(defaultSelectCountry);
    setSelectedCountryDetails(defaultSelectCountry);
  }

  const handleSelectedIndex = (id) => {
    const defaultSelectCountry = data?.countries?.find(
      (option) => Number(option.id) === Number(id)
    );

    setSelectedCountry(defaultSelectCountry);
    setSelectedCountryDetails(defaultSelectCountry);
  };

  const options = data?.countries?.map((country) => ({
    label: country.name,
    value: country.id,
    icon: country.icon,
  }));

  const afroCompany = data?.countries?.find(
    (option) => Number(option?.id) === Number(1)
  );

  const defaultSelectCountry = selectedCountry
    ? {
        label: selectedCountry?.name,
        icon: selectedCountry?.icon,
        value: selectedCountry?.id,
      }
    : {
        label: afroCompany?.name,
        icon: afroCompany?.icon,
        value: afroCompany?.id,
      };

  const defaultSelectCountryDetails = selectedCountryDetails
    ? {
        ...selectedCountry,
      }
    : {
        ...afroCompany,
      };
  return (
    <>
      <div className="row mb-5" style={{ zIndex: "1000000!important" }}>
        <div className="col-12 col-md-6 mx-auto shadow-sm p-0">
          <Select
            defaultValue={defaultSelectCountry}
            formatOptionLabel={formatOptionLabel}
            options={options}
            onChange={handleSelect}
            key={selectedCountry?.id || 1}
          />
        </div>
      </div>
      <div className="d-lg-none py-5">
        <div className="container">
          <div>
            <img
              src={`${IMAGE_BASE_URL}/${defaultSelectCountryDetails?.image}`}
              alt={selectedCountry?.name}
              className="img-fluid h-100 w-100"
            />
            <div className="p-3 fs-16">
              <h2 className="fs-32 gilroy-bold">
                {defaultSelectCountryDetails?.name}
              </h2>
              <p>
                <span className="gilroy-bold">Country Manager</span> :{" "}
                {defaultSelectCountryDetails?.country_manager}
              </p>
              <p>
                <span className="gilroy-bold">Company Type</span> :{" "}
                {defaultSelectCountryDetails?.company_type}
              </p>
              <p>
                <span className="gilroy-bold">Address</span> :{" "}
                {defaultSelectCountryDetails?.address}
              </p>

              <p>
                <span className="gilroy-bold">Phone </span>:{" "}
                {defaultSelectCountryDetails?.phone}
              </p>
              <p>
                {" "}
                <span className="gilroy-bold">Email</span> :{" "}
                {defaultSelectCountryDetails?.email}
              </p>
              <div>
                <button
                  className="px-4 me-3 bg-american-yellow inline-block border-0 outline-0 text-white"
                  style={{ paddingTop: "6px", paddingBottom: "6.5px" }}
                  onClick={() =>
                    handleShowContactForm(defaultSelectCountryDetails?.id)
                  }
                >
                  Contact
                </button>
                <a
                  href={`https://wa.me/${defaultSelectCountryDetails?.whats_app_no}`}
                  target="_blank"
                  rel="noreferrer"
                  className="px-4 py-3 bg-success border-0 outline-0 text-white inline-block fs-14 text-decoration-none"
                >
                  WhatsApp
                </a>
                <Link
                  to={`/countries/project/${defaultSelectCountryDetails?.id}`}
                  className="ms-3 px-4 py-3 bg-primary border-0 outline-0 text-white inline-block fs-14 text-decoration-none"
                >
                  Project
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="position-relative">
        <CompanyLocationMaps
          companies={companies}
          handleSelectedIndex={handleSelectedIndex}
        />
        <div
          className="h-100 position-absolute top-0 end-0 bg-white d-none d-lg-block"
          style={{ width: "400px" }}
        >
          <div className="">
            <div>
              <img
                src={`${IMAGE_BASE_URL}/${defaultSelectCountryDetails?.image}`}
                alt={selectedCountry?.name}
                className="img-fluid h-100 w-100"
              />
              <div className="p-3 fs-16">
                <h2 className="fs-32 gilroy-bold">
                  {defaultSelectCountryDetails?.name}
                </h2>
                <p>
                  <span className="gilroy-bold">Country Manager</span> :{" "}
                  {defaultSelectCountryDetails?.country_manager}
                </p>
                <p>
                  <span className="gilroy-bold">Company Type</span> :{" "}
                  {defaultSelectCountryDetails?.company_type}
                </p>
                <p>
                  <span className="gilroy-bold">Address</span> :{" "}
                  {defaultSelectCountryDetails?.address}
                </p>

                <p>
                  <span className="gilroy-bold">Phone </span>:{" "}
                  {defaultSelectCountryDetails?.phone}
                </p>
                <p>
                  {" "}
                  <span className="gilroy-bold">Email</span> :{" "}
                  {defaultSelectCountryDetails?.email}
                </p>
                <div>
                  <button
                    className="px-5 bg-american-yellow me-3 inline-block border-0 outline-0 text-white"
                    style={{ paddingTop: "6px", paddingBottom: "6.5px" }}
                    onClick={() =>
                      handleShowContactForm(defaultSelectCountryDetails?.id)
                    }
                  >
                    Contact
                  </button>
                  <a
                    href={`https://wa.me/${defaultSelectCountryDetails?.whats_app_no}`}
                    target="_blank"
                    rel="noreferrer"
                    className="px-5 py-3 bg-success border-0 outline-0 text-white inline-block fs-14 text-decoration-none"
                  >
                    WhatsApp
                  </a>
                  <Link
                    to={`/countries/project/${defaultSelectCountryDetails?.id}`}
                    className="ms-3 px-5 py-3 bg-primary border-0 outline-0 text-white inline-block fs-14 text-decoration-none"
                  >
                    Project
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <ContactFormModal
          countryInfo={data?.countries?.filter(
            (item) => item?.id === selectedContactForm
          )}
          showDialog={showModal}
          close={close}
        />
      )}
    </>
  );
};

export default CountryMap;
